import React, { useState, useEffect, useContext } from "react";
import { API } from "../common/api-service";
import ReactHtmlParser from "react-html-parser";
import AuthContext from "../common/AuthContext";
import { useLocation } from "react-router-dom";

export default function PostDetail() {
  const location = useLocation();
  const [title, setTitle] = useState("");
  const [body, setBody] = useState("");
  const [notes, setNotes] = useState("");
  const [active, setActive] = useState(false);
  const [number_of_view, setNumberOfView] = useState(0);

  const { authState } = useContext(AuthContext);
  const token = authState.token.slice(1, -1);

  useEffect(() => {
    if (location.state) {
      if (location.state.id) {
        var post_id = location.state.id;
        API.getItem("posts", post_id, token)
          .then((resp) => {
            setTitle(resp.title);
            setBody(resp.body);
            setNotes(resp.notes);
            setActive(resp.active);
            setNumberOfView(resp.number_of_view);
          })
          .catch((error) => console.log(error));
      }
    }
    window.scrollTo(0, 0);
  }, []);

  return (
    <React.Fragment>
      <div className="content-wrapper">
        <section className="content-header">
          <div className="container-fluid">
            <div className="row mb-2">
              <div className="col-sm-6">
                <h1>Post Detail</h1>
              </div>
              <div className="col-sm-6">
                <ol className="breadcrumb float-sm-right">
                  <li className="breadcrumb-item">
                    <a href="#">Home</a>
                  </li>
                  <li className="breadcrumb-item active">Post Detail</li>
                </ol>
              </div>
            </div>
          </div>
          {/* /.container-fluid */}
        </section>
        {/* Main content */}
        <section className="content">
          <div className="card card-default">
            <div className="card-header">
              <h3 className="card-title">{title}</h3>
            </div>
            <div className="card-body">
              <div className="row">
                <div className="col-md-12">
                  <div className="form-group clearfix ck-content">
                    Nội dung: {body ? ReactHtmlParser(body) : ""}
                  </div>
                </div>
              </div>
              <div className="row">
                <div className="col-md-12">
                  <div className="form-group clearfix ck-content">
                    Notes: {notes ? ReactHtmlParser(notes) : ""}
                  </div>
                </div>
              </div>
              <div className="row">
                <div className="col-md-12">
                  <div className="form-group clearfix ck-content">
                    Active: {active ? "Active" : "Không active"}
                  </div>
                </div>
              </div>
              <div className="row">
                <div className="col-md-12">
                  <div className="form-group clearfix ck-content">
                    Number of view: {number_of_view}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
    </React.Fragment>
  );
}
